export default class BatchCommand {
    constructor(children, description = 'Batch') {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = description;
        this.category = 'structure';
        this.children = children;
    }

    execute() {
        this.children.forEach(c => c.execute());
    }

    undo() {
        [...this.children].reverse().forEach(c => c.undo());
    }

    toJSON() {
        return {
            type: 'Batch',
            id: this.id,
            timestamp: this.timestamp,
            payload: { children: this.children.map(c => c.toJSON()) },
        };
    }
}
